import consumer from "./consumer"

const initTranslationCable = (onIncomingTranslation) => {
  const translationChannel = consumer.subscriptions.create(
    { channel: "TranslationChannel" },
    {
      received(data) {
        if (data.type === "incoming_translation") {
          onIncomingTranslation(data.from);
        }
      },

      sendTranslation(identity) {
        this.perform("start_translation", { from: identity });
      }
    }
  );

  return translationChannel;
};

export { initTranslationCable };
